module.exports = __webpack_public_path__ + "static/media/mBank-Bold.ce5f2196.woff";